import { render, staticRenderFns } from "./confirmReceiptOrPayment.vue?vue&type=template&id=08f529d9&scoped=true&"
import script from "./confirmReceiptOrPayment.vue?vue&type=script&lang=js&"
export * from "./confirmReceiptOrPayment.vue?vue&type=script&lang=js&"
import style0 from "./confirmReceiptOrPayment.vue?vue&type=style&index=0&id=08f529d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f529d9",
  null
  
)

component.options.__file = "confirmReceiptOrPayment.vue"
export default component.exports